import routerOptions0 from "/usr/src/app/content/n3-spas-51c60ead-ea7d-4dbe-a09e-5df19627cb9c/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}